// app/javascript/controllers/review_controller.js
import { Controller } from "@hotwired/stimulus"
import { partySetupRequest, signInForPartySetup } from './support/party_setup_request'

export default class extends Controller {
    static values = { draftId: Number, draftSgid: String, invitationSlug: String }

    // Previous step
    back() {
        const qs = this._qs()
        window.location.assign(`/party/additional-info?${qs}`)
    }

    details() {
        const qs = this._qs()
        window.location.assign(`/party/details?${qs}`)
    }

    design() {
        const qs = this._qs()
        window.location.assign(`/party/editor?${qs}`)
    }

    // Continue (same as Save for now; adjust route when you wire persistence)
    continue() { this.save() }

    async save() {
        if (this.saving) return
        this.saving = true
        const Toast = (title, icon="info") =>
            Swal.fire({ toast:true, icon, title, position:"bottom-end", timer:0, showConfirmButton:false });

        Toast("Saving your party, hold on! 🎉");
        try {
            // finalize
            const id = this.draftIdValue;
            const finalize = () => partySetupRequest(`/party_drafts/${id}/finalize`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
                },
                body: JSON.stringify({})
            }, { requiresAccount: true });
            let resp = await finalize();
            if (resp.status === 401) {
                if (!await signInForPartySetup(Swal)) {
                    this.saving = false
                    return
                }
                Toast("Saving your party, hold on! 🎉")
                resp = await finalize()
            }

            if (!resp.ok) {
                const j = await resp.json().catch(()=>({}));
                throw new Error(j?.errors?.join(", ") || "Could not save your party");
            }

            const { manage_url } = await resp.json();
            Swal.update({ icon: "success", title: "Preparing Dashboard 🥳" });
            setTimeout(() => { window.location.assign(manage_url); }, 600);
        } catch (e) {
            this.saving = false
            Swal.update({ icon: "error", title: e.message || "Save failed - please try again" });
            setTimeout(()=> Swal.close(), 1800);
        }
    }

    _qs() {
        const base = (this.hasDraftSgidValue && this.draftSgidValue)
            ? `draft_sgid=${encodeURIComponent(this.draftSgidValue)}`
            : `draft_id=${encodeURIComponent(this.draftIdValue)}`
        const slug = this.hasInvitationSlugValue ? `&invitation=${encodeURIComponent(this.invitationSlugValue)}` : ""
        return `${base}${slug}`
    }
}
